module.exports = __webpack_public_path__ + "static/img/logo-BRISBANE-LIONS.2fec504.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-BRISBANE-LIONS.svg
// module id = xP52
// module chunks = 1